<a *ngIf="insertAssigned" (click)="goToOngoingByMe()" class="insert assigned">
  <div>👀 <span [innerHTML]="insertAssigned"></span></div>
  <mat-icon>chevron_right</mat-icon>
</a>
<a *ngIf="insertOnHold" (click)="goToOngoingByMe()" class="insert on-hold">
  <div>👀 <span [innerHTML]="insertOnHold"></span></div>
  <mat-icon>chevron_right</mat-icon>
</a>
<a *ngIf="insertHelpResquest" (click)="goToHelpRequest()" class="insert help-request">
  <div>👀 <span [innerHTML]="insertHelpResquest"></span></div>
  <mat-icon>chevron_right</mat-icon>
</a>
